import {  BoundCallbackObservable  } from './BoundCallbackObservable';

export const bindCallback = BoundCallbackObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/bindCallback.ts